export default "__VITE_ASSET__C9edw4$$__"